import { render, staticRenderFns } from "./no-default-route.vue?vue&type=template&id=60a058bc&scoped=true"
import script from "./no-default-route.vue?vue&type=script&lang=ts"
export * from "./no-default-route.vue?vue&type=script&lang=ts"
import style0 from "./no-default-route.vue?vue&type=style&index=0&id=60a058bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a058bc",
  null
  
)

export default component.exports